import { memo, useState, useRef, useEffect } from 'react';
import { Spin, Space, Button, Divider, Image } from 'antd';
import isEqual from 'lodash.isequal';
import { TrailCard } from 'shared/Card/Card';
import { DeleteOutlined, FileImageOutlined, CloseCircleFilled } from '@ant-design/icons';
import { LoadingSpinner } from 'shared/LoadingSpinner/LoadingSpinner';
import { S } from './FlatCardsList.styles';
import { FlatCardsListProps } from './FlatCardsList.interface';
import { CartItemFrontend } from '../../store/CartStore';
import { GuideType } from '../../atlasguides-web-common/src/functions/guides/dto/guide.dto';
import { isBundleWithoutGeo } from '../../utils/isBundleWithoutGeo';
import { formatPrice } from 'utils/formatUtils';



interface ShopifyLineItem {
  id: any;
  title: any;
  variant: any;
}

const FlatCardsListComponent: React.FC<FlatCardsListProps> = ({
  itemsBeingDeleted,
  areTrailsLoading,
  handleDelete,
  handleOpen,
  lineItems,
  handleRemoveShopifyItem,
}) => {

  var initialRemoveMap = new Map<string, boolean>();
  if (lineItems) {
    lineItems.map(item => {
      initialRemoveMap.set(item.id, false);
    });
  }
  const [removalMap, setRemovalMap] = useState<Map<string, boolean>>(initialRemoveMap);
  const updateMap = (k:string, v:boolean) => {
    setRemovalMap(new Map(removalMap.set(k,v)));
  }
  return (
    <S.Container>
    {lineItems !== undefined && lineItems.map(
      ({
        id,
        title,
        variant
      }) => {
        const lineItem = {
          id,
          title,
          variant
        } as ShopifyLineItem;
        console.log("FLAT CARDS LINE IITEM: ", lineItem);

        return (
          <S.CardWrapper key={id}>
            <div style={{ display: 'flex', width: '100%', height: '100%', alignItems:'center'}}>
              <div style={{display: 'flex', width: '25%', height:'100%', padding:5, }}>

                {variant.image && <img style={{borderRadius: 5}} src={variant.image.url} alt={title} width="100%" height="100%"/>}
                {!variant.image && <img style={{borderRadius: 5}} src="data:image/png;base64,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"
 alt={title} width="100%" height="100%"/>}
              </div>
              <div style={{display: 'inline-block', width: '60%', padding:15}}>
              <h3>{title}</h3>
              <p>{formatPrice(variant.price.amount, variant.price.currencyCode)}</p>
              </div>
              <div style={{display: 'flex', width: '15%'}}>
              {removalMap.get(id)
                ? <LoadingSpinner size="large"/>
                : <CloseCircleFilled
                  onClick={()=>
                    {
                      updateMap(id, true);
                      handleRemoveShopifyItem?
                        handleRemoveShopifyItem(id):
                        console.log("FAILED")
                    }
                  }
                  style={{color:'#adadad', fontSize: '36px'}}
                />
              }



              </div>


            </div>
            <Divider />
          </S.CardWrapper>
        );
      }
    )}
      {/*trailsList.map(
        ({
          itemUid,
          guideName,
          guidePromoText,
          guideIcon,
          guideLength,
          guidePrice,
          guideDiscountAmount,
          guideDiscountPercent,
          guideId,
          shopifyVariantId,
          isPurchased,
          showPromoPrice,
          guideType,
          guideHasOpenButton,
        }) => {
          const cartItem = {
            itemUid,
            guideId,
            shopifyVariantId,
            guideIcon,
            guideName,
            guidePrice,
            guideDiscountAmount,
            guideDiscountPercent,
            guideType,
          } as CartItemFrontend;
          const itemIsBeingDeleted =
            itemsBeingDeleted && guideId in itemsBeingDeleted;
          return (
            <S.CardWrapper key={guideId}>
              <TrailCard
                shape="flat"
                size="small"
                guideId={guideId}
                shopifyVariantId={shopifyVariantId}
                guideName={guideName}
                guidePromoText={guidePromoText}
                guideLength={guideLength}
                guidePrice={guidePrice}
                guideIcon={guideIcon}
                isPurchased={isPurchased}
                showPromoPrice={showPromoPrice}
                isDeletionInProgress={itemIsBeingDeleted}
                onDelete={
                  handleDelete
                    ? event => {
                        event.stopPropagation();
                        handleDelete(cartItem as any);
                      }
                    : undefined
                }
                onOpen={
                  handleOpen ? () => handleOpen(cartItem as any) : undefined
                }
                guideHasOpenButton={guideHasOpenButton}
                openButtonTitle={
                  isBundleWithoutGeo(guideType) ? 'Show bundle' : 'Open'
                }
              />
            </S.CardWrapper>
          );
        }
      )*/}
      {areTrailsLoading && (
        <Space size="middle">
          <Spin />
        </Space>
      )}
    </S.Container>
  );
};

export const FlatCardsList = memo(FlatCardsListComponent, isEqual);
